import React, { useState, useEffect } from 'react';
import { TreeSelect } from 'antd';
import './index.scss';
import _ from 'lodash';
import { analyzeLog, clstagStr } from '../../../../utils/util';
import { CLSTAG } from '@/utils/constant';

type Iprop = {
  label: string;
  className?: string;
  onChange: AnyFunc;
  options: {
    label: string;
    value: string;
    count: number;
    labelCount: string;
  }[];
  clstag?: CLSTAG;
};
const MultiSelectComp = (props: Iprop) => {
  const { label, options, className, onChange, clstag } = props;
  const [selectedValues, setSelectedValues] = useState<any>(
    options.map(({ value }) => value),
  );
  useEffect(() => {
    setSelectedValues(options.map(({ value }) => value));
  }, [options]);
  return (
    <div
      className={`multi-select-wrapper ${className || ''}`}
      clstag={clstag && clstagStr(clstag)}
    >
      <span>{label}</span>
      <TreeSelect
        showSearch={false}
        onChange={(value, labelList, extra) => {
          setSelectedValues(value);
          // 行为打点
          analyzeLog(
            'vehicleType_dropdown',
            `{"selectedValue":${JSON.stringify(labelList)}}`,
          );
          if (extra.triggerValue === '' && extra.checked) {
            setSelectedValues(options.map(({ value }) => value));
            onChange(options.map(({ value }) => value));
            return;
          } else if (extra.triggerValue === '' && !extra.checked) {
            setSelectedValues([]);
            onChange([]);
            return;
          } else if (
            labelList.indexOf('全部') === -1 &&
            labelList.length === options.length - 1
          ) {
            setSelectedValues(options.map(({ value }) => value));
            onChange(options.map(({ value }) => value));
            return;
          } else if (
            labelList.indexOf('全部') >= 0 &&
            labelList.length <= options.length - 1
          ) {
            const arr = [];
            for (let i = 0; i < options.length; i++) {
              if (
                options[i].value !== '' &&
                options[i].value !== extra.triggerValue
              ) {
                arr.push(options[i].value);
              }
            }
            onChange(arr);
            setSelectedValues(arr);
            return;
          }
          onChange(value);
        }}
        fieldNames={{
          label: `labelCount`,
          value: 'value',
        }}
        value={selectedValues}
        treeCheckable={true}
        maxTagCount={1}
        treeData={options}
        treeNodeLabelProp={'label'}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
      ></TreeSelect>
    </div>
  );
};

export default React.memo(MultiSelectComp);
